export const articles = [
  {
    id: 1,
    title: '三十岁那年，我终于学会了与自己和解',
    slug: 'sanshi-sui-yu-ziji-hejie',
    category: 'xinling-chengzhang',
    excerpt: '曾经以为三十岁意味着成功与完美，直到真正走到这个年纪才发现，接纳不完美的自己才是最大的成长。',
    content: `<p>三十岁的钟声敲响时，我正坐在出租屋的阳台上，看着城市的万家灯火。那一刻，我突然意识到自己并没有成为二十岁时想象的那个"成功人士"。</p><p>没有豪车，没有大房子，甚至连一份称心如意的工作都谈不上。但奇怪的是，我并不像几年前那样焦虑了。</p><p>二十多岁的时候，我总觉得自己必须要在某个节点完成某些事情。二十五岁要升职，二十八岁要结婚，三十岁之前必须买房。这些数字像一座座大山压在心头，让人喘不过气。</p><p>可是生活从来不会按照你预设的剧本走。它会给你惊喜，也会给你挫折。真正重要的不是你达到了什么高度，而是你在攀登的过程中成为了什么样的人。</p><p>三十岁这年，我终于明白：与自己和解不是放弃追求，而是学会在奔跑中也能欣赏路边的风景。我不再苛求自己完美，而是感谢每一个努力的当下。</p><p>如果你也正处在迷茫中，请记住：你走的每一步都算数，你经历的每一件事都是礼物。慢慢来，比较快。</p>`,
    author: '星辰大海',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20warm%20smile%20natural%20lighting%20simple%20cream%20background%20soft%20photography%20style%20clean%20minimal&width=120&height=120&seq=avatar-01&orientation=squarish',
    date: '2026-08-08',
    readCount: 12580,
    commentCount: 326,
    likes: 2891,
    image: 'https://readdy.ai/api/search-image?query=peaceful%20sunset%20cityscape%20from%20balcony%20warm%20golden%20light%20cozy%20apartment%20atmosphere%20emotional%20calm%20reflective%20mood%20soft%20bokeh%20lights&width=800&height=500&seq=article-01&orientation=landscape',
    tags: ['自我成长', '人生感悟', '三十岁'],
  },
  {
    id: 2,
    title: '异地恋三年，我们用这些方法维持了最初的温度',
    slug: 'yidi-lian-san-nian',
    category: 'qinggan-qingsu',
    excerpt: '一千多个日夜的分离，没有让我们的感情变淡，反而因为彼此的努力而更加深厚。',
    content: `<p>异地恋，大概是所有恋爱模式里最难的一种。看不见摸不着，所有的喜怒哀乐都只能通过冰冷的屏幕传递。</p><p>但我和他，硬是走过了三年，并且感情越来越好。今天想分享一些我们的真实经验。</p><p><strong>第一，建立仪式感。</strong>我们约定每天晚上十点视频通话，不管多忙都必须做到。这不是任务，而是一天中最期待的时刻。每周五晚上是我们固定的"电影之夜"，同时打开同一部电影，开着视频一起看。</p><p><strong>第二，保持分享欲。</strong>很多人异地久了就开始报流水账，最后变成"吃了没""吃了""早点睡""嗯"。我们会刻意分享生活里的小事：路上看到的可爱小狗、同事讲的好笑段子、食堂出了什么新菜品。</p><p><strong>第三，制造惊喜。</strong>我会在他加班时偷偷给他点外卖，他会在纪念日给我寄手写信。这些小心思让距离变得不那么遥远。</p><p>异地恋很难，但如果是那个对的人，一切都值得。距离从来不是问题，心远才是。</p>`,
    author: '樱花树下',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20gentle%20smile%20portrait%20natural%20daylight%20cream%20background%20clean%20simple%20aesthetic&width=120&height=120&seq=avatar-02&orientation=squarish',
    date: '2026-08-07',
    readCount: 18930,
    commentCount: 521,
    likes: 4203,
    image: 'https://readdy.ai/api/search-image?query=two%20smartphones%20facing%20each%20other%20on%20wooden%20table%20warm%20ambient%20light%20cozy%20room%20rose%20petals%20scattered%20romantic%20atmosphere%20emotional%20connection&width=800&height=500&seq=article-02&orientation=landscape',
    tags: ['异地恋', '恋爱技巧', '情感故事'],
  },
  {
    id: 3,
    title: '辞职回乡创业的第六个月，我想和你说说心里话',
    slug: 'cizhi-huixiang-chuangye',
    category: 'zhichang-rensheng',
    excerpt: '从一线城市白领到乡村创业者，这条路远比想象中艰难，但也比想象中有意义。',
    content: `<p>去年冬天，我辞掉了在上海月薪两万的工作，回到了老家——一个只有三千人的小镇。</p><p>所有亲戚都说我疯了。爸妈气得半个月没和我说话。朋友觉得我是被城市生活压垮了。</p><p>但我知道自己在做什么。我想把家乡的特产通过电商卖出去，让更多人尝到小时候的味道。</p><p>前三个月是最难的。不懂电商运营，被快递公司坑过，产品质量不稳定被退货。有几次深夜打包到凌晨三点，腰都直不起来，心里问自己：到底图什么？</p><p>转折出现在第四个月。一个美食博主无意中买了我们的产品，在视频里夸了一句"这才是小时候的味道"。那天晚上，订单突然爆了。</p><p>现在第六个月，我们已经有了稳定的回头客，还雇了村里两个阿姨帮忙打包。虽然赚的钱还没有上海工资多，但每天早上推开窗看到青山绿水，心里特别踏实。</p><p>如果你也在犹豫要不要跳出舒适圈，我想说：年轻的时候，不妨大胆一点。失败了又怎样，至少你试过。</p>`,
    author: '山里人老张',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20in%20thirties%20warm%20friendly%20smile%20outdoor%20natural%20light%20simple%20background%20clean%20portrait%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    date: '2026-08-06',
    readCount: 22100,
    commentCount: 687,
    likes: 5102,
    image: 'https://readdy.ai/api/search-image?query=beautiful%20Chinese%20countryside%20landscape%20green%20mountains%20traditional%20village%20houses%20golden%20sunset%20light%20peaceful%20rural%20scene%20warm%20earthy%20tones&width=800&height=500&seq=article-03&orientation=landscape',
    tags: ['创业故事', '回乡', '人生选择'],
  },
  {
    id: 4,
    title: '婆婆搬来住的第一年，我们经历了什么',
    slug: 'popo-banlai-di-yi-nian',
    category: 'jiating-guanxi',
    excerpt: '同住一个屋檐下，从摩擦不断到相互理解，这一年教会了我太多。',
    content: `<p>结婚第三年，婆婆因为身体原因搬来和我们同住。说实话，我当时心里是抗拒的。</p><p>果然，矛盾来得比想象中更快。第一周就因为"菜太咸"吵了一架。婆婆说我不懂照顾她儿子，我说她管得太多。老公夹在中间左右为难。</p><p>那段时间，家里的气氛压抑到了极点。我开始在网上搜索"婆媳相处之道"，看了很多过来人的经验分享。</p><p>后来我试着换了一个角度：婆婆年纪大了，她的很多行为不是针对我，而是出于关心和习惯。我开始主动找她聊天，问她年轻时候的故事，向她请教做菜的技巧。</p><p>慢慢地，我发现她其实是个很可爱的人。她会偷偷给我买我爱吃的水果，会在我加班时给我留饭，会跟我讲老公小时候的糗事。我也学会了包容她的唠叨，理解她的孤独。</p><p>现在，我们已经是很好的"闺蜜"了。家庭关系的秘诀其实很简单：多一份理解，少一点计较。</p>`,
    author: '小太阳麻麻',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20gentle%20warm%20smile%20portrait%20indoor%20soft%20lighting%20simple%20background%20clean%20aesthetic%20photography&width=120&height=120&seq=avatar-04&orientation=squarish',
    date: '2026-08-05',
    readCount: 15670,
    commentCount: 442,
    likes: 3678,
    image: 'https://readdy.ai/api/search-image?query=warm%20cozy%20living%20room%20two%20women%20drinking%20tea%20together%20afternoon%20sunlight%20streaming%20through%20window%20Chinese%20home%20interior%20harmonious%20atmosphere%20soft%20colors&width=800&height=500&seq=article-04&orientation=landscape',
    tags: ['婆媳关系', '家庭相处', '生活感悟'],
  },
  {
    id: 5,
    title: '在北京的第五年，我学会了和孤独做朋友',
    slug: 'beijing-wu-nian-gudu',
    category: 'shenghuo-gushi',
    excerpt: '漂在北京的第五个年头，一个人吃饭、一个人逛街、一个人过节，孤独反而让我更了解自己。',
    content: `<p>五年前拖着行李箱站在北京西站的那一刻，我对未来充满憧憬。大城市、好机会、新生活，一切都很美好。</p><p>但现实是：第一个月租房就被中介坑了押金，第一份工作加班到凌晨是常态，第一个春节因为抢不到票一个人在出租屋吃泡面。</p><p>最难受的是孤独。周末醒来不知道找谁吃饭，生病了只能自己打车去医院，过生日的时候只有银行和运营商发来祝福短信。</p><p>但奇怪的是，当你和孤独相处久了，你反而会觉得自在。一个人看电影可以看到深夜，一个人旅行可以想停就停，一个人吃饭可以细细品味每一道菜。</p><p>孤独不是坏事，它让你有时间和自己对话，让你更清楚自己想要什么。现在的我，依然一个人，但不再害怕一个人。</p><p>致所有在外漂泊的你：孤独是成长的必修课，熬过去，你会感谢这段时光。</p>`,
    author: '北漂小鱼',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20thoughtful%20expression%20portrait%20city%20background%20natural%20light%20clean%20simple%20style%20modern&width=120&height=120&seq=avatar-05&orientation=squarish',
    date: '2026-08-04',
    readCount: 20150,
    commentCount: 598,
    likes: 4500,
    image: 'https://readdy.ai/api/search-image?query=Beijing%20city%20skyline%20at%20dusk%20warm%20evening%20light%20solitary%20figure%20looking%20out%20window%20modern%20apartment%20reflective%20mood%20urban%20landscape%20soft%20atmosphere&width=800&height=500&seq=article-05&orientation=landscape',
    tags: ['北漂', '孤独', '城市生活'],
  },
  {
    id: 6,
    title: '那些年我们一起追过的女孩，现在都怎么样了',
    slug: 'naxienian-zhui-guode-nvhai',
    category: 'shenghuo-gushi',
    excerpt: '高中毕业十年聚会，看到了当年暗恋的班花，突然感慨时光的力量。',
    content: `<p>上周末参加了高中毕业十周年聚会，见到了很多十年未见的老同学。</p><p>最让我感慨的，是当年全班男生都暗恋的班花小雅。记忆中她总是扎着马尾，笑起来有两个浅浅的酒窝，成绩好、性格温柔，是完美的代名词。</p><p>十年后再见，她胖了一点，剪了短发，穿着普通的T恤牛仔裤，抱着两岁的女儿来参加聚会。聊天才知道，她大学毕业后回了老家，嫁给了一个普通的公务员，日子过得平淡却幸福。</p><p>反倒是当年最不起眼的"书呆子"小王，现在成了某互联网公司的技术总监，开着一辆特斯拉来参加聚会，举手投足间全是自信。</p><p>人生就是这样有趣。你以为的那些"人生赢家"，可能正在羡慕你的生活。每个人都有自己的时区，不早不晚，刚刚好。</p><p>聚会结束后，大家约好明年再见。但我心里知道，有些人这一别可能就是一辈子了。珍惜当下吧，朋友们。</p>`,
    author: '老同学阿明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20friendly%20smile%20portrait%20casual%20style%20natural%20lighting%20simple%20background%20clean%20portrait&width=120&height=120&seq=avatar-06&orientation=squarish',
    date: '2026-08-03',
    readCount: 28700,
    commentCount: 823,
    likes: 6290,
    image: 'https://readdy.ai/api/search-image?query=class%20reunion%20dinner%20scene%20warm%20restaurant%20ambient%20lighting%20group%20of%20friends%20laughing%20together%20nostalgic%20atmosphere%20Chinese%20dining%20table%20happy%20moment&width=800&height=500&seq=article-06&orientation=landscape',
    tags: ['青春回忆', '同学聚会', '人生感悟'],
  },
  {
    id: 7,
    title: '单亲妈妈的日常：累并幸福着',
    slug: 'danqin-mama-richang',
    category: 'jiating-guanxi',
    excerpt: '一个人带孩子到底有多难？说实话，很难。但你问我后悔吗？一点也不。',
    content: `<p>离婚那年，儿子才三岁。所有人都在劝我："一个女人带孩子太苦了，趁年轻赶紧再找一个。"</p><p>但我选择了独自抚养。不为别的，就是觉得与其在将就的婚姻里消耗自己，不如一个人活得坦荡。</p><p>当然，难是真的难。早上六点起床做早饭和午饭便当，七点半送孩子上学，八点半赶到公司。下午五点接孩子，六点做饭，八点辅导作业，十点孩子睡了才能有自己的时间。</p><p>最难的是孩子生病。有一次儿子半夜发高烧，我抱着他在医院走廊等了三小时，又困又怕又累，眼泪止不住地流。但天亮后，还是要擦干眼泪去上班。</p><p>但幸福也是真的幸福。儿子第一次写"妈妈我爱你"的小卡片，他攒了好久的零花钱给我买生日礼物，他睡觉前一定要抱着我说"妈妈最漂亮"。</p><p>这些瞬间，让所有的辛苦都值得。</p><p>单亲妈妈不可怜，我们只是选择了另一种活法。孩子们，妈妈会努力成为你的骄傲。</p>`,
    author: '坚强的向日葵',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20warm%20determined%20smile%20portrait%20soft%20natural%20light%20simple%20background%20clean%20minimal%20style&width=120&height=120&seq=avatar-07&orientation=squarish',
    date: '2026-08-02',
    readCount: 19850,
    commentCount: 710,
    likes: 5310,
    image: 'https://readdy.ai/api/search-image?query=mother%20and%20young%20child%20playing%20together%20in%20sunlit%20room%20warm%20golden%20afternoon%20light%20cozy%20home%20atmosphere%20loving%20moment%20soft%20natural%20photography&width=800&height=500&seq=article-07&orientation=landscape',
    tags: ['单亲妈妈', '亲子', '生活'],
  },
  {
    id: 8,
    title: '我在上海送外卖的这一年',
    slug: 'shanghai-song-waimai',
    category: 'zhichang-rensheng',
    excerpt: '一个985毕业生的外卖骑手自述：每一份工作都值得被尊重。',
    content: `<p>你可能会好奇，一个985大学毕业的人为什么会去送外卖。</p><p>答案很简单：公司裁员了。在那之前，我已经投了上百份简历，石沉大海。房贷要还，家里要养，面子和生存之间，我选择了生存。</p><p>刚开始送外卖的时候，最怕遇到熟人。把头盔压得低低的，希望不要被认出来。有一次在写字楼遇到了前同事，我假装不认识，低着头走过去了。事后觉得又好笑又心酸。</p><p>但真正开始做这份工作后，我的想法完全改变了。我见过凌晨四点就开始扫街的环卫工人，见过深夜还在改方案的打工人，见过在医院走廊偷偷抹泪的家属。</p><p>每个人都在努力地活着，没有谁比谁高贵。</p><p>外卖骑手这份工作让我看到了社会的另一面。不是每个人都坐在办公室里喝着咖啡开电话会议，更多的人是在风吹日晒中奔波。</p><p>现在我已经找到新工作了，但那一年送外卖的经历让我学会了谦卑和感恩。如果你正在经历人生的低谷，请记住：这只是暂时的，你比想象中更强大。</p>`,
    author: '低调的外卖哥',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20honest%20smile%20portrait%20outdoor%20natural%20light%20simple%20background%20clean%20style&width=120&height=120&seq=avatar-08&orientation=squarish',
    date: '2026-08-01',
    readCount: 35200,
    commentCount: 1240,
    likes: 8900,
    image: 'https://readdy.ai/api/search-image?query=Shanghai%20city%20streets%20at%20night%20neon%20lights%20delivery%20scooter%20on%20road%20urban%20night%20scene%20warm%20street%20lamps%20busy%20city%20life%20cinematic%20mood&width=800&height=500&seq=article-08&orientation=landscape',
    tags: ['外卖骑手', '职场故事', '人生低谷'],
  },
  {
    id: 9,
    title: '和闺蜜认识了二十年，我们的友情秘诀',
    slug: 'guimi-ershi-nian-youqing',
    category: 'shenghuo-gushi',
    excerpt: '二十年，我们从穿校服的小女孩变成了各自城市里的中年女人，但友情从未褪色。',
    content: `<p>前几天翻相册，看到一张初中时的老照片。照片里三个扎着马尾的女孩对着镜头比剪刀手，笑得没心没肺。那就是我们——我、小雨和阿琳。</p><p>二十年过去了，我们在三个不同的城市生活，各自有了家庭和孩子。但每年我们一定会找时间聚一次。有时候是一起旅行，有时候只是去某个人家里住两天。</p><p>有人问我们友情的秘诀是什么。我想了想，大概是这几点：</p><p><strong>不攀比，真心为对方高兴。</strong>小雨升职，我和阿琳真心感到骄傲。阿琳生了二胎，我们比她还激动。闺蜜之间，最怕的就是嫉妒和比较。</p><p><strong>不勉强，但永远在。</strong>群里的消息可以隔天才回复，但谁要是发了一句"我好难过"，另外两个一定会马上打电话过去。</p><p><strong>说真话，但温柔地说。</strong>我们之间没有塑料友情。做错事会直接指出，但用的都是最温柔的方式。</p><p>女生的友情很美好，维系它需要用心。希望我们都珍惜身边那个可以一起哭一起笑的姐妹。</p>`,
    author: '三姐妹的老大',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20bright%20warm%20smile%20portrait%20natural%20daylight%20simple%20background%20clean%20minimal%20photography&width=120&height=120&seq=avatar-09&orientation=squarish',
    date: '2026-07-31',
    readCount: 16800,
    commentCount: 465,
    likes: 3990,
    image: 'https://readdy.ai/api/search-image?query=three%20women%20friends%20walking%20together%20on%20beach%20at%20sunset%20laughing%20golden%20light%20warm%20atmosphere%20friendship%20bonding%20peaceful%20ocean%20scene&width=800&height=500&seq=article-09&orientation=landscape',
    tags: ['闺蜜', '友情', '生活感悟'],
  },
  {
    id: 10,
    title: '老公出轨后，我是如何重建生活的',
    slug: 'laogong-chugui-chongjian',
    category: 'qinggan-qingsu',
    excerpt: '发现真相的那一刻，天塌了。但一年后的今天，我很好，而且比从前更好。',
    content: `<p>去年的今天，我在他的手机里发现了他和另一个女人的聊天记录。那一刻，心脏像被狠狠捏碎。</p><p>我们结婚七年，有一个五岁的女儿。我一直以为自己是幸福的。</p><p>接下来是长达三个月的黑暗期。失眠、暴瘦、反复自我怀疑。"是不是我不够好？""是不是我做错了什么？"每天都在这两个问题里打转。</p><p>转折发生在一个普通的下午。女儿画了一幅画给我，上面是她拉着我的手，旁边歪歪扭扭写着"妈妈笑"。我突然意识到，我不能倒下，因为还有一个小人儿需要我。</p><p>我开始看心理医生，开始去健身房，开始重新联系那些因为婚姻疏远的朋友。慢慢地，笑容回到了脸上。</p><p>离婚协议签完那天，我以为自己会哭，但奇怪的是，我感到前所未有的轻松。</p><p>现在的我，有一份喜欢的工作，有一个可爱的女儿，有一群关心我的朋友。生活依然美好，只是换了一种方式。</p><p>如果你正在经历类似的痛苦，请相信：这不是你的错，你值得被好好对待。天亮了，一切都会好的。</p>`,
    author: '涅槃的凤凰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20confident%20strong%20smile%20portrait%20professional%20look%20soft%20natural%20light%20simple%20background%20elegant&width=120&height=120&seq=avatar-10&orientation=squarish',
    date: '2026-07-30',
    readCount: 41200,
    commentCount: 1580,
    likes: 10200,
    image: 'https://readdy.ai/api/search-image?query=silhouette%20of%20woman%20standing%20at%20window%20facing%20sunrise%20new%20beginning%20hope%20warm%20golden%20morning%20light%20strength%20and%20resilience%20inspirational%20atmosphere&width=800&height=500&seq=article-10&orientation=landscape',
    tags: ['婚姻', '重建生活', '女性力量'],
  },
  {
    id: 11,
    title: '从小县城到大城市：一个普通女孩的逆袭之路',
    slug: 'xiaoxiancheng-dao-dachengshi',
    category: 'xinling-chengzhang',
    excerpt: '没有背景、没有人脉、没有名校光环，一个县城女孩如何在城市里站稳脚跟。',
    content: `<p>我出生在一个十八线小县城，父母都是普通工人。高考那年，我考上了省城一所二本学校，那是我第一次离开家乡。</p><p>大学四年，我是图书馆的常客。同学们逛街、谈恋爱、打游戏的时候，我在啃专业书、考证书、学英语。不是不想玩，而是我知道——除了努力，我什么都没有。</p><p>毕业那年，我带着三千块钱来到了现在这座城市。住过地下室，吃过一个月的泡面，面试被拒绝了三十多次。每次打电话回家，都说"我挺好的"，挂了电话就哭。</p><p>第一份工作月薪三千五，做最基础的数据录入。但我抓住每一个学习的机会，主动帮同事分担工作，下班后自学编程和数据分析。</p><p>三年后跳槽，工资翻了三倍。五年后成为部门主管。现在八年过去了，我在这个城市有了自己的房子、车子和一群志同道合的朋友。</p><p>回望这一路，最想说的是：出身不能选择，但人生可以。只要你不放弃自己，世界就不会放弃你。</p>`,
    author: '追光的兔子',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20confident%20professional%20portrait%20modern%20office%20background%20natural%20light%20clean%20style%20elegant&width=120&height=120&seq=avatar-11&orientation=squarish',
    date: '2026-07-29',
    readCount: 26300,
    commentCount: 890,
    likes: 7200,
    image: 'https://readdy.ai/api/search-image?query=modern%20city%20skyline%20at%20sunrise%20from%20high%20rise%20building%20warm%20golden%20morning%20light%20urban%20landscape%20hope%20and%20opportunity%20inspirational%20mood&width=800&height=500&seq=article-11&orientation=landscape',
    tags: ['逆袭', '成长故事', '励志'],
  },
  {
    id: 12,
    title: '退休后，我爸成了抖音上最快乐的老人',
    slug: 'tuixiu-baba-douyin',
    category: 'shenghuo-gushi',
    excerpt: '原以为退休后他会无聊，没想到他在短视频平台上找到了新的人生舞台。',
    content: `<p>去年我爸退休了。刚开始那段时间，他像丢了魂似的，每天坐在沙发上看电视，话也不说，饭也吃得少。</p><p>我和妈妈都很担心，试着带他去公园下棋、去老年大学学书法，他都不感兴趣。</p><p>直到有一天，他在抖音上刷到了几个同龄人分享日常的视频。他好奇地问我怎么拍视频，我帮他注册了账号，简单教了教怎么用。</p><p>没想到，这一教就"坏事"了。我爸彻底迷上了拍短视频。他的账号叫"老李头的快乐生活"，内容就是做菜、种花、遛弯、和老朋友聊天。有时候还会配上几句打油诗。</p><p>半年过去了，他的粉丝居然涨到了两万多。现在他比我还忙，每天研究拍什么内容、怎么剪辑、和粉丝互动。</p><p>前几天他兴奋地告诉我，有个粉丝给他寄了一箱特产表示感谢。看着他满脸的成就感，我突然明白：退休不是人生的终点，而是新生活的起点。只要保持好奇心，什么时候开始都不晚。</p>`,
    author: '老李的女儿',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20warm%20family%20portrait%20smile%20soft%20lighting%20simple%20background%20clean%20aesthetic&width=120&height=120&seq=avatar-12&orientation=squarish',
    date: '2026-07-28',
    readCount: 14500,
    commentCount: 380,
    likes: 3450,
    image: 'https://readdy.ai/api/search-image?query=elderly%20Chinese%20man%20smiling%20happily%20filming%20with%20smartphone%20in%20garden%20sunny%20day%20colorful%20flowers%20warm%20joyful%20atmosphere%20active%20senior%20lifestyle&width=800&height=500&seq=article-12&orientation=landscape',
    tags: ['退休生活', '家庭', '快乐'],
  },
];

export function getArticlesByCategory(slug: string) {
  return articles.filter((a) => a.category === slug);
}

export function getArticleBySlug(slug: string) {
  return articles.find((a) => a.slug === slug);
}

export function getRelatedArticles(currentSlug: string, category: string, limit = 3) {
  return articles
    .filter((a) => a.slug !== currentSlug && a.category === category)
    .slice(0, limit);
}